import ApiService from '../api.service';
import { LocaleService } from '../storage.service';

export default {
    async getObjectsHouses(itemsPerPage, currentItem, iWhereOrderLocale) {
        const { data: response } = await ApiService.post('prescription_ozp/getObjectsHouses', { itemsPerPage, currentItem, iWhereOrderLocale });
        return response.data;
    },
    async getPrescriptionsOZP(itemsPerPage, currentItem, iWhereOrderLocale) {
        const { data: response } = await ApiService.post('prescription_ozp/getPrescriptions', { itemsPerPage, currentItem, iWhereOrderLocale });
        return response.data;
    },
    async getReqs(itemsPerPage, currentItem, iWhereOrderLocale) {
        const { data: response } = await ApiService.post('prescription_ozp/getReqs', { itemsPerPage, currentItem, iWhereOrderLocale });
        return response.data;
    },
    async getEventTypes() {
        const { data: response } = await ApiService.get('prescription_ozp/getEventTypes');
        return response.data;
    },
    async getConsumptionCategory() {
        const { data: response } = await ApiService.get('prescription_ozp/getConsumptionCategory');
        return response.data;
    },
    async postPrescriptionsOZP(nvcPrescriptionData) {
        const { data: response } = await ApiService.post('prescription_ozp/postPrescriptions', { nvcPrescriptionData });
        return response.data;
    },
    async postReqOZP(nvcPrescriptionRequestData) {
        const { data: response } = await ApiService.post('prescription_ozp/postReq', { nvcPrescriptionRequestData });
        return response.data;
    },
    async getPrescriptionOZPInfo(id) {
        const { data: response } = await ApiService.post('prescription_ozp/getPrescriptionInfo', { id });
        return response.data;
    },
    async getReqOZPInfo(id) {
        const { data: response } = await ApiService.post('prescription_ozp/getReqInfo', { id });
        return response.data;
    },
    async prescriptionOZPStatusChange(iPrescription_rid, iStatus_rid, comment) {
        const { data: response } = await ApiService.get('prescription_ozp/prescriptionStatusChange', {
            params: {
                iPrescription_rid,
                iStatus_rid,
                comment
            }
        });
        return response.data;
    },
    async saveSignedActReadyPrescription({ file, guid, prescriptionRid, statusRid }) {
        const formData = new FormData();

        formData.append('file', file);

        const { data: response } = await ApiService.post('prescription_ozp/saveSignedActReadyPrescription', formData, {
            params: {
                guid,
                iPrescription_rid: prescriptionRid,
                iStatus_rid: statusRid
            },
            showLoader: true
        });

        return response.data;
    },
    async prescriptionOZPStatusTypes() {
        const { data: response } = await ApiService.get('prescription_ozp/prescriptionStatusTypes');
        return response.data;
    },
    async getEngineerKSKHousesList(iengineer_rid) {
        const { data: response } = await ApiService.get('prescription_ozp/getEngineerKSKHousesList', {
            params: {
                iengineer_rid
            }
        });
        return response.data;
    },
    async getEngineerContractsList(iengineer_rid) {
        const { data: response } = await ApiService.get('prescription_ozp/getEngineerContractsList', {
            params: {
                iengineer_rid
            }
        });
        return response.data;
    },
    async getReqContractsList() {
        const { data: response } = await ApiService.get('prescription_ozp/getReqContractsList');
        return response.data;
    },
    async getEngineerObjectsList(iengineer_rid) {
        const { data: response } = await ApiService.get('prescription_ozp/getEngineerObjectsList', {
            params: {
                iengineer_rid
            }
        });
        return response.data;
    },
    async getPeriodsList() {
        const { data: response } = await ApiService.get('prescription_ozp/getPeriodsList');
        return response.data;
    },
    async getKSKList() {
        const { data: response } = await ApiService.get('prescription_ozp/getKSKList');
        return response.data;
    },
    async engineerObjectContractsList(icontract_rid, iengineer_rid) {
        const { data: response } = await ApiService.get('prescription_ozp/engineerObjectContractsList', {
            params: {
                icontract_rid,
                iengineer_rid
            }
        });
        return response.data;
    },
    async getPrescriptionInfoToSign(id) {
        const { data: response } = await ApiService.get('prescription_ozp/getPrescriptionToSign', {
            params: { id }
        });
        return response.data;
    },
    async getActReadyInfoToSign(id) {
        const { data: response } = await ApiService.get('prescription_ozp/getActReadyToSign', {
            params: { id }
        });
        return response.data;
    },
    async saveFilePrescription({ file, guid }) {
        try {
            //const { file, guid } = payload;
            const formData = new FormData();

            formData.append('file', file);

            const response = await ApiService.post('prescription_ozp/attachmentsLinkInsert', formData, { params: { guid }, showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    async reqSetExec(iRequest_rid, dDate, user_id) {
        const { data: response } = await ApiService.get('prescription_ozp/reqSetExec', {
            params: { iRequest_rid, dDate, user_id }
        });
        return response.data;
    },
    async reqStatusChange(iRequest_rid, iStatus_rid, user_id, comment) {
        const { data: response } = await ApiService.get('prescription_ozp/reqStatusChange', {
            params: { iRequest_rid, iStatus_rid, user_id, comment }
        });
        return response.data;
    },
    async getNotifications(params = {}) {


        const { data: response } = await ApiService.get('prescription_ozp/notifications', {
            params
        });



        return response.data;
    },
    async getUnreadNotificationsCount() {
        const limit = 100;

        let offset = 0;
        let totalItems = 0;
        let unreadCount = 0;

        do {
            const { data: response } = await ApiService.get('prescription_ozp/notifications', {
                params: {
                    limit,
                    offset
                }
            });

            const data = response.data || {};

            const notifications = Array.isArray(data.ahs_requests) ? data.ahs_requests : [];

            totalItems = Number(data.pagination?.row_count) || 0;

            unreadCount += notifications.filter(notification => !notification.notification_read).length;

            offset += limit;
        } while (offset < totalItems);

        return unreadCount;
    },
    async markNotificationAsRead(recordId) {
        const { data: response } = await ApiService.post('prescription_ozp/notifications/mark-as-read', {
            record_id: recordId
        });

        return response.data;
    }
};
